<div class="modal-header u-border-bottom-grey mb-3">
  <h4 class="modal-title-top20">
    {{ 'addToCartItems.prodDetails' | cxTranslate }}
  </h4>
  <div class="cls-btn" (click)="close()">
    <i
      class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover mr-3 mt-4">
    </i>
  </div>
</div>
<div class="modal-body">
  <div class="row row-20 product-details pb-3" id="leftCont-rightNav">
    <section class="row row-20">
      <section class="container-pdp">
        <aside
          aria-label="Product Details"
          class="col-xs-12 col-sm-4 col-md-4 right-navigation float-right">
          <a *ngIf="productDetails?.images && !productDetails?.images?.PRIMARY">
            <img
              class="image-prod"
              src="{{ baseUrl }}{{ productDetails.images[0]?.url }}"
              alt="prodImg" />
          </a>
          <a *ngIf="productDetails?.images?.PRIMARY">
            <img
              class="image-prod"
              src="{{ productDetails?.images?.PRIMARY?.product?.url }}"
              alt="prodImg" />
          </a>
          <a
            *ngIf="
              productDetails?.images === undefined ||
              productDetails?.images?.length === 0
            ">
            <img class="image-prod" [src]="fallbackImage" alt="defImg" />
          </a>
        </aside>
        <section class="col-xs-12 col-sm-8 col-md-8 pb-2 float-left">
          <section class="row">
            <section class="col-md-10">
              <h3 class="pdp-title" [innerHTML]="productDetails?.name"></h3>
              <p
                class="desc-class"
                [innerHTML]="productDetails?.description"></p>
            </section>
          </section>

          <br />
          <section class="batch-info">
            <p
              class="desc-title"
              *ngIf="productDetails?.batchInfo?.batchNumber">
              {{ 'plp.batchNumber' | cxTranslate }}
              <span class="desc-details">{{
                productDetails?.batchInfo?.batchNumber
              }}</span>
            </p>
            <p
              class="desc-title"
              *ngIf="productDetails?.batchInfo?.batchNumber">
              {{ 'plp.expiryDate' | cxTranslate }} :
              <span class="desc-details">{{
                productDetails?.batchInfo?.expiryDate
              }}</span>
            </p>
            <p class="desc-title">
              {{ 'plp.productNumber' | cxTranslate }}
              <span class="desc-details">{{ productDetails?.sapEan }}</span>
            </p>
            <hr class="line" />

            <section class="third-col">
              <section class="row unit-calc">
                <section
                  class="col-md-4 col-xs-6 bottom-spacing price-area"
                  [ngStyle]="{
                    visibility:
                      (isPharmacyUser$ | async) || !productDetails.flu
                        ? 'visible'
                        : 'hidden',
                  }">
                  <b>{{ 'selectVaccines.yourPrice' | cxTranslate }}</b>
                  <section class="number">
                    <span>{{
                      (productDetails?.basePrice?.formattedValue ||
                        productDetails?.price?.formattedValue) ??
                        '-'
                    }}</span>
                  </section>
                </section>

                <section
                  class="bottom-spacing availability-text"
                  *ngIf="
                    !productDetails?.discontinued &&
                    !productDetails?.sapAllocation &&
                    !productDetails?.flu
                  "></section>
              </section>
            </section>
          </section>
        </section>
        <aside
          aria-label="Product Details Pdf "
          class="col-sm-3 right-navigation float-left resources-section">
          <section *ngIf="monographLink">
            <section class="product-details-pdf color-primary">
              <p class="mt-3 pb-1 font-bold">
                {{ 'plp.resources' | cxTranslate }}
              </p>
              <p class="c-link">
                <i class="fa fa-file-pdf"></i>
                <a alt=" " href="{{ monographLink }}" target="_blank">{{
                  'plp.monograph' | cxTranslate
                }}</a>
              </p>
            </section>
          </section>
        </aside>
      </section>
    </section>
  </div>
</div>
